import { createSelector } from 'reselect';

// Config
import { shouldShowOrderPersonalisation } from '../order-personalisation/OrderPersonalisation.state';
import { getIsApplicationSelector } from '@redux/reducers/app/appSelector';
import { getSelectedCollectionPointSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';

const orderDetailsState = createSelector(
  [getSelectedCollectionPointSelector, shouldShowOrderPersonalisation, getIsApplicationSelector],
  (selectedCollectionPoint, showOrderPersonalisation, isApplication) => ({
    selectedCollectionPoint,
    showOrderPersonalisation,
    showSurvey: isApplication,
  }),
);

export default orderDetailsState;
